import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import editing from 'assets/img/icons/spot-illustrations/21.png';

const Texts = () => {
  return (
    <Card>
      <Card.Body className="overflow-hidden p-lg-6">
        <Row className="align-items-center justify-content-between">
          <Col lg={6}>
            <img src={editing} className="img-fluid" alt="" />
          </Col>
          <Col lg={6} className="ps-lg-4 my-5 text-center text-lg-start">
            <h3 className="text-primary">Texts</h3>
            <p className="lead">The list of texts will go here.</p>
            <p>
              Users with the appropriate rights will be able to edit the texts.
            </p>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default Texts;
